module.exports = __webpack_public_path__ + "img/cb6-y1.0fc86bc8.gif";